import { useState, useRef, useEffect } from 'react';
import { Badge, Popover, Space, Button, Input } from 'antd';
import { Session } from '..';
import { DashOutlined } from '@ant-design/icons';
import styles from '../index.less';


interface IndexProps {
  vo: Session;
  count: number;
  activeChat: string;
  handleEvent: (type: string, id: string, text?: string) => void;
  handleClick: (id: string) => void;
}


const Index: React.FC<IndexProps> = ({ vo, count, activeChat, handleEvent, handleClick }) => {
  const [modify, setModify] = useState<boolean>(false);
  const [text, setText] = useState<string>(vo.name);

  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (modify) {
      if (inputRef.current) inputRef.current.focus();
    }
  }, [modify])

  const handle = (type: string) => {
    if (['清空', '删除'].includes(type)) {
      handleEvent(type, vo.id);
    } else {
      setModify(true);
    }
  }

  return <>
    {
      modify ? <div className={styles.chatItem}>
        <Input
          ref={inputRef}
          style={{ background: 'transparent', color: '#fff' }}
          value={text}
          onChange={e => setText(e.target.value)}
          onBlur={() => {
            if (text !== vo.name && text) {
              handleEvent("编辑名称", vo.id, text);
            } else {
              setText(vo.name);
            }
            setModify(false);
          }}
        />
      </div> : <Badge count={count} dot offset={[-4, 8]}><div
        key={vo.id}
        className={`${styles.chatItem} ${activeChat === vo.id && styles.activeChat}`}
        onClick={() => handleClick(vo.id)}
      >
        {vo.name}
        <Popover style={{ padding: 0 }} placement="right" content={<Space direction="vertical">
          {
            ['清空', '删除', '编辑名称'].map(type => <Button
              key={type}
              style={{ border: 'none', width: '100%' }}
              onClick={e => {
                e.stopPropagation();
                handle(type);
              }}
            >{type}</Button>)
          }
        </Space>}>
          <DashOutlined />
        </Popover>
      </div></Badge>
    }
  </>
}

export default Index;